import { GENDER_TYPE } from '@common/types';
import {
  addOptionalToSchema,
  pastDateSchema,
  optionalNameSchema,
  phoneSchema,
  requiredErrorMessage,
  requiredNameSchema,
  stateSchema,
  zipSchema,
} from '@common/schema';
import * as yup from 'yup';
import { MAXIMUM_STRING_LENGTH } from '@common/types/constants.ts';

export const createPatientSchema = yup
  .object({
    first_name: requiredNameSchema,
    middle_name: optionalNameSchema,
    last_name: requiredNameSchema,
    preferred_name: yup.string().max(MAXIMUM_STRING_LENGTH).optional(),

    gender: yup
      .string()
      .oneOf(Object.values(GENDER_TYPE))
      .required(requiredErrorMessage),
    birthdate: pastDateSchema.required(requiredErrorMessage),
    provider_type: yup
      .string()
      .oneOf(['Internal', 'External', 'Unknown'])
      .required(requiredErrorMessage),

    practice_id: yup.string().required(requiredErrorMessage),
    provider_id: yup
      .string()
      .when('provider_type', ([provider_type], schema) =>
        provider_type === 'Internal'
          ? schema.required(requiredErrorMessage)
          : schema,
      ),

    provider_first_name: optionalNameSchema.when(
      'provider_type',
      ([provider_type], schema) =>
        provider_type === 'External'
          ? schema.required(requiredErrorMessage)
          : schema,
    ),
    provider_last_name: optionalNameSchema.when(
      'provider_type',
      ([provider_type], schema) =>
        provider_type === 'External'
          ? schema.required(requiredErrorMessage)
          : schema,
    ),
    provider_phone: phoneSchema.when(
      'provider_type',
      ([provider_type], schema) =>
        provider_type === 'External'
          ? schema.required(requiredErrorMessage)
          : schema,
    ),

    lives_at_home: yup
      .string()
      .oneOf(['true', 'false'])
      .required(requiredErrorMessage),

    google_places_id: yup
      .string()
      .when('lives_at_home', ([lives_at_home], schema) =>
        lives_at_home === 'true'
          ? schema.required(requiredErrorMessage)
          : schema,
      ),

    street: optionalNameSchema.when(
      'lives_at_home',
      ([lives_at_home], schema) =>
        lives_at_home === 'true'
          ? schema.required(requiredErrorMessage)
          : schema,
    ),
    suite: optionalNameSchema,
    room: optionalNameSchema,

    city: optionalNameSchema.when('lives_at_home', ([lives_at_home], schema) =>
      lives_at_home === 'true' ? schema.required(requiredErrorMessage) : schema,
    ),
    state: stateSchema.when('lives_at_home', ([lives_at_home], schema) =>
      lives_at_home === 'true'
        ? schema.required(requiredErrorMessage)
        : addOptionalToSchema(schema),
    ),
    zip_code: zipSchema.when('lives_at_home', ([lives_at_home], schema) =>
      lives_at_home === 'true'
        ? schema.required(requiredErrorMessage)
        : addOptionalToSchema(schema),
    ),
    county: optionalNameSchema,

    building_id: yup
      .string()
      .when('lives_at_home', ([lives_at_home], schema) =>
        lives_at_home === 'false'
          ? schema.required(requiredErrorMessage)
          : schema.optional(),
      ),
    building_unit: yup
      .string()
      .when('lives_at_home', ([lives_at_home], schema) =>
        lives_at_home === 'false'
          ? schema
              .required(requiredErrorMessage)
              .oneOf(
                [
                  'assisted_living',
                  'memory_care',
                  'senior_living',
                  'independent_living',
                ],
                requiredErrorMessage,
              )
          : schema.optional(),
      ),
  })
  .required();
